// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#27241a","secondaryColor":"#333333","activeColor":"#d6c792","textColor":"#dddbd1"};